import { Component, Input, Output, EventEmitter, QueryList, ElementRef, ViewChild, ContentChildren, AfterViewInit } from '@angular/core';

import * as _ from 'lodash';

import { TabComponent } from './tab.component';

@Component({
  selector: 'uex-tab-group',
  templateUrl: './tab-group.component.html',
  host: {
    class: 'uex-tab-group'
  }
})
export class TabGroupComponent implements AfterViewInit {
  @ViewChild('scrollableElement', { static: true }) private _scrollable_element: ElementRef;
  @ContentChildren(TabComponent)
  private set _tabs(tabs: QueryList<TabComponent>) {
    this.tabs = tabs.toArray().filter((tab) => tab.type !== 'button');
    this.button_tabs = tabs.toArray().filter((tab) => tab.type === 'button');
    this._selectTab(false);
  }

  @Input('selectedIndex')
  set selected(tabIndex: number) {
    if (this._ready) {
      this.select(tabIndex);
    } else {
      this._selected = tabIndex;
    }
  }
  get selected(): number {
    return _.isNumber(this._selected) && this.tabs && this._selected < this.tabs.length ? this._selected : 0;
  }
  @Output('onChange') private _onChange: EventEmitter<TabChangeEvent> = new EventEmitter();

  constructor(public elementRef: ElementRef) { }

  private _selected: number = 0;
  private _ready: boolean = false;

  public alreadySelectedTabs: Array<number> = [];

  public tabs: Array<TabComponent>;
  public button_tabs: Array<TabComponent>;

  public ngAfterViewInit() {
    setTimeout(() => {
      this._ready = true;
      this._selectTab(false);
    }, 0);
  }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public onTabClick(tabIndex: number, event: MouseEvent) {
    event.preventDefault();
    this.select(tabIndex);
  }

  /** Emit an event when clicking in a tab button */
  public onTabButtonClick(tab: TabComponent, event: MouseEvent){
    event.preventDefault();
    tab.onClick.emit(event)
  }

  public select(tabIndex: number) {
    if (this._ready) {
      const currentTab = this.currentTab(tabIndex);
      if (tabIndex >= 0 && tabIndex != this._selected && currentTab && !currentTab.disabled) {
        this._selected = parseInt(tabIndex.toString());
        this._selectTab();
      }
    } else {
      setTimeout(() => this.select(tabIndex), 100);
    }
  }

  public currentTab(tabIndex: number = this.selected): TabComponent {
    return this.tabs[tabIndex];
  }

  public alreadySelected(index: number): boolean {
    return this.alreadySelectedTabs.indexOf(index) > -1;
  }

  public hasControls() {
    if(this._scrollable_element) {
      return this._scrollable_element.nativeElement.scrollWidth > this._scrollable_element.nativeElement.clientWidth;
    }

    return false;
  }

  public scrollToPrevTab() {
    if(this._scrollable_element) {
      const items: Array<HTMLDivElement> = this._scrollable_element.nativeElement.querySelectorAll('.nav-item');
      const scroll_offset = this._scrollable_element.nativeElement.scrollLeft;

      if(scroll_offset === 0) return;

      let scroll_to: number = -1;
      items.forEach((item) => {
        if(scroll_to >= 0) return;

        const start_offset = item.offsetLeft - scroll_offset;
        const end_offset = item.offsetLeft + item.clientWidth - scroll_offset;
        if(start_offset < 0 && end_offset >= 0) {
          scroll_to = start_offset + scroll_offset;
        }
      });

      if(scroll_to >= 0) {
        this._scrollable_element.nativeElement.scrollTo({
          top: 0,
          left: scroll_to,
          behavior: 'smooth'
        });
      }
    }
  }

  public scrollToNextTab() {
    if(this._scrollable_element) {
      const items: Array<HTMLDivElement> = this._scrollable_element.nativeElement.querySelectorAll('.nav-item');
      const max_offset = this._scrollable_element.nativeElement.clientWidth - 15;
      const scroll_width = this._scrollable_element.nativeElement.scrollWidth;
      const scroll_offset = this._scrollable_element.nativeElement.scrollLeft;

      if(scroll_width - scroll_offset === (max_offset + 15)) return;

      let scroll_to: number = 0;
      items.forEach((item) => {
        if(scroll_to > 0) return;

        const start_offset = item.offsetLeft - scroll_offset;
        const end_offset = item.offsetLeft + item.clientWidth - scroll_offset;
        if(start_offset <= max_offset && end_offset > max_offset) {
          scroll_to = end_offset - max_offset + scroll_offset;
        }
      });

      if(scroll_to > 0) {
        this._scrollable_element.nativeElement.scrollTo({
          top: 0,
          left: scroll_to,
          behavior: 'smooth'
        });
      }
    }
  }

  public tabTrackByFn(index: number, tab: TabComponent): any {
    return index;
  }

  private _selectTab(emit_event: boolean = true) {
    if (!this.tabs) return;
    const currentTab = this.tabs[this.selected];
    if (!this._ready || (this._ready && currentTab && currentTab.disabled)) return;
    let active_tab: TabComponent;

    this.tabs.forEach((_tab, index) => {
      if (index != this.selected || _tab.disabled) {
        _tab.active = false;
      } else {
        _tab.active = true;
        active_tab = _tab;
      }
    });

    this._updateAlreadySelectedTabs();

    if(emit_event) {
      this._onChange.emit({
        tab: active_tab,
        index: this.selected
      });
    }
  }

  private _updateAlreadySelectedTabs() {
    if (this.alreadySelectedTabs.indexOf(this.selected) == -1) this.alreadySelectedTabs.push(this.selected);
  }
}
export interface TabChangeEvent {
  tab: TabComponent;
  index: number;
}
